import vireal from "../pict/web-1.png";
import tindog from "../pict/web-2.png";
import drumKit from "../pict/web-3.png";
import dice from "../pict/web-4.png";
import simonGame from "../pict/web-5.png";
import todoList from "../pict/web-6.png";
import presensee from "../pict/web-7.png";
import redesign from "../pict/web-8.png";
import oldWebsite from "../pict/web-9.png";
import todoListEJS from "../pict/web-10.png";
import tellSecret from "../pict/web-11.png";
import blog from "../pict/web-12.png";
import note from "../pict/web-13.png";
import news from "../pict/web-14.png";
import twitter from "../pict/web-15.png";
import prayTime from "../pict/web-17.png";
// import holadok from "../pict/web-16.png"

const project = [
  // {
  //   key: 15,
  //   time: "January 2023",
  //   title: "Holadok Hero Component",
  //   content:
  //     "The Holadok Hero component is a visually striking and highly functional element of a doctor appointment website. It is a key part of the website's overall aesthetic and user experience, and can be used to showcase the benefits and features of the website",
  //   image: holadok,
  //   srcCode: "https://github.com/chezapangestu/Holadok",
  //   link: "https://holadok-component.netlify.app/",
  //   tech1: "ReactJS",
  //   tech2: "TailwindCSS"
  // },
  {
    key: 15,
    time: "May 2023",
    title: "Azaan and Prayer Time",
    content:
      "Pray time using API from aladhan.com for shalat in Musholla Masjid Al Barokah Pesona Bali City View Residence Perumahan Pesona Bali City View, Ciwaruga, Kabupaten Bandung Barat",
    image: prayTime,
    srcCode: "https://github.com/chezapangestu/al-barokah-PBCVR",
    link: "https://clock-al-barokah-pbcvr.vercel.app/",
    tech1: "NextJS",
    tech2: "TailwindCSS",
  },
  {
    key: 14,
    time: "January 2023",
    title: "Twitter Card Component",
    content:
      "Twitter Card is a simple card that displays a single tweet from Twitter. It includes the user's avatar, name, username, the tweet itself, the total number of likes, and the date it was published",
    image: twitter,
    srcCode: "https://github.com/chezapangestu/twitter-embed",
    link: "https://twitter-card-component.netlify.app/",
    tech1: "ReactJS",
    tech2: "TailwindCSS",
  },
  {
    key: 0,
    time: "December 2022",
    title: "News Space Flights",
    content:
      "A website that provides the latest trending information about space flight using the API and also using the ReactJS framework",
    image: news,
    srcCode: "https://github.com/chezapangestu/news-space-flights",
    link: "https://cz-news-spase-flight.netlify.app/",
    tech1: "ReactJS",
    tech2: "CSS",
  },
  {
    key: 1,
    time: "December 2022",
    title: "Redesign Portfolio Web",
    content:
      "Redesign my website using reactJS by implementing components in react like react hooks and also using TailwindCSS",
    image: redesign,
    srcCode: "https://github.com/chezapangestu/chezapangestu.github.io",
    link: "https://cheza.netlify.app/",
    tech1: "ReactJS",
    tech2: "TailwindCSS",
  },
  {
    key: 2,
    time: "December 2022",
    title: "To-do-list",
    content:
      "Simple todolist application made with JavaScript and Svelte Framework",
    image: todoList,
    srcCode: "https://github.com/chezapangestu/ToDoList-svelte",
    link: "https://cz-todolist.netlify.app/",
    tech1: "JavaScript",
    tech2: "Svelte",
    tech3: "HTML",
    tech4: "CSS",
  },
  {
    key: 3,
    time: "November 2022",
    title: "Drum Kit",
    content:
      "A drum kit is a collection of drums such as kick, snare, hi-hat, crash, and tom, where you can play beats for drums that are made by JavaScript using implemented Document Object Model (DOM)",
    image: drumKit,
    srcCode: "https://github.com/chezapangestu/drumkitJS",
    link: "https://chezapangestu.github.io/drumkitJS/",
    tech1: "JavaScript",
    tech2: "HTML",
    tech3: "CSS",
  },
  {
    key: 4,
    time: "November 2022",
    title: "Simon Game",
    content:
      "The Simon game is an exciting electronic game of lights and sounds in which players must repeat random sequences of lights by pressing the colored pads in the correct order, which is made using JavaScript and jQuery library",
    image: simonGame,
    srcCode: "https://github.com/chezapangestu/Simon-game-challenge",
    link: "https://chezapangestu.github.io/Simon-game-challenge/",
    tech1: "JavaScript",
    tech2: "jQuery",
    tech3: "HTML",
    tech4: "CSS",
  },
  {
    key: 5,
    time: "November 2022",
    title: "Dice Winner",
    content:
      "Application to determine the winner between 2 players using a dice that randomly uses JavaCcript by refreshing the page",
    image: dice,
    srcCode: "https://github.com/chezapangestu/dice-winner",
    link: "https://chezapangestu.github.io/dice-winner/",
    tech1: "JavaScript",
    tech2: "HTML",
    tech3: "CSS",
  },
  {
    key: 6,
    time: "November 2022",
    title: "Tindog",
    content:
      "Tinder website, but the user who uses it is a dog. It is an independent learning website about responsive design using Bootstrap",
    image: tindog,
    srcCode: "https://github.com/chezapangestu/tindog-bootstrap",
    link: "https://chezapangestu.github.io/tindog-bootstrap/",
    tech1: "HTML",
    tech2: "Bootstrap",
  },
  {
    key: 7,
    time: "November 2022 . Back-end",
    title: "To-do-list using ExpressJS",
    content:
      "Create a to-do list with the ExpressJS Framework and then input the list data into the MongoDB database",
    image: todoListEJS,
    srcCode: "https://github.com/chezapangestu/to-do-list-EJS",
    tech1: "NodeJS",
    tech2: "ExpressJS",
    tech3: "MongoDB",
  },
  {
    key: 8,
    time: "November 2022 . Back-end",
    title: "Tell The Secret",
    content:
      "Website for uploading a secret, but the user who posted the secret cannot be known by anyone. All secrets that have been dispatched will be visible to all users. Using passport.js to be able to register/login with a google account.",
    image: tellSecret,
    srcCode: "https://github.com/chezapangestu/tell-the-secret",
    tech1: "NodeJS",
    tech2: "ExpressJS",
    tech3: "MongoDB",
  },
  {
    key: 9,
    time: "November 2022 . Back-end",
    title: "Blog Space",
    content:
      "A website to be able to post like a blog. Each item can be clicked to see the details of the page content",
    image: blog,
    srcCode: "https://github.com/chezapangestu/blog-with-mongoDB",
    tech1: "NodeJS",
    tech2: "ExpressJS",
    tech3: "MongoDB",
  },
  {
    key: 10,
    time: "November 2022 . Back-end",
    title: "Sticky Note's",
    content:
      "Sticky notes but with a website version to be able to add a note and also delete it. You can input as many notes as possible, like a sticky note on the wall that you often stick",
    image: note,
    srcCode: "https://github.com/chezapangestu/notes-app-react",
    tech1: "ReactJS",
    tech2: "CSS",
  },
  {
    key: 11,
    time: "October 2022",
    title: "Old Portfolio Web",
    content:
      "Self-learning to build my portfolio website using essential components like HTML and CSS",
    image: oldWebsite,
    srcCode: "https://github.com/chezapangestu/web-porto-html",
    link: "https://chezapangestu.github.io/web-porto-html/",
    tech1: "HTML",
    tech2: "CSS",
  },
  {
    key: 12,
    time: "March 2022",
    title: "ViReal",
    content:
      "Is a product of ViReal products that sells virtual expo and webinar events with virtual reality using Framework Codeigniter 4 and PHP",
    image: vireal,
    srcCode: "https://github.com/chezapangestu/vireal.website",
    link: "http://vireal.live/",
    tech1: "PHP",
    tech2: "CodeIgniter4",
    tech3: "Bootstrap",
  },
  {
    key: 13,
    time: "June 2022",
    title: "Presensee Mockup Website",
    content:
      "Presensee is a website to monitor the absence and health of children in school during face-to-face learning through the attendance list, and the temperature of students detected so that information can be sent to parents",
    image: presensee,
    proto:
      "https://www.figma.com/proto/fBAgzs0hkCmkgmJZzKqSSZ/Presensee?node-id=157%3A1302&scaling=min-zoom&page-id=60%3A627&starting-point-node-id=157%3A1302&show-proto-sidebar=1",
    tech1: "FigmaPrototype",
  },
];

export default project;
